import { ApolloLink } from './ApolloLink';

export const execute = ApolloLink.execute;



// WEBPACK FOOTER //
// ../../../src/link/core/execute.ts